import React from 'react';
import { Platform } from 'react-native';
import { Provider as ReduxProvider } from 'react-redux';
import AsyncStorage from '@react-native-community/async-storage';
import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import { PersistGate } from 'redux-persist/integration/react';
import thunk from 'redux-thunk';

import authentication from './authentication/reducer';
import ui from './ui/reducer';
import { Actions, State } from './types';

const rootReducer = combineReducers<State, Actions>({
  // @ts-ignore
  authentication,
  // @ts-ignore
  ui,
});

const persistConfig = {
  key: 'Persistor',
  storage: AsyncStorage,
  whitelist: [],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

let composeEnhancers = compose;

if (process.env.NODE_ENV === 'development') {
  composeEnhancers =
    // @ts-ignore
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || composeEnhancers;

  if (Platform.OS !== 'web') {
    // const createFlipperMiddleware = require("rn-redux-middleware-flipper").default;
    // middlewares.push(createFlipperMiddleware());
  }
}
const store = createStore(
  persistedReducer,
  composeEnhancers(applyMiddleware(thunk))
);

const persistor = persistStore(store);

const Component: React.FC = ({ children }) => {
  return (
    <PersistGate loading={null} persistor={persistor}>
      <ReduxProvider store={store}>{children}</ReduxProvider>
    </PersistGate>
  );
};

Component.displayName = 'Store';

export default Component;
